import { ThemeProvider as ThemeProviderMui, GlobalStyles, CssBaseline } from '@mui/material'
import { theme, responsiveVars } from '@/config/theme'

type ThemeProviderProps = {
  children?: React.ReactNode
}

const ThemeProvider = ({ children }: ThemeProviderProps) => {
  return (
    <ThemeProviderMui theme={theme} noSsr>
      <CssBaseline />
      <GlobalStyles
        styles={theme =>
          Object.fromEntries(
            theme.breakpoints.keys.map(breakpoint => {
              const vars: Record<string, string> = {}

              responsiveVars.forEach((responsiveVar: any) => {
                if (breakpoint in responsiveVar && responsiveVar[breakpoint]) {
                  const cssVar = responsiveVar[breakpoint]
                  const currentVar = cssVar
                    .replace(/^var\(/, '')
                    .replace(/\)$/, '')
                    .split(', ')[0]
                    .replace(`-${breakpoint}`, '-current')

                  vars[currentVar] = cssVar
                }
              })

              return [
                theme.breakpoints.up(breakpoint),
                {
                  'html:not(#fake-id-for-specificity):root': {
                    '--current-breakpoint': breakpoint,
                    ...vars,
                  },
                },
              ]
            }),
          )
        }
      />
      {children}
    </ThemeProviderMui>
  )
}

export default ThemeProvider
